import React from 'react'
import styled from 'styled-components'
import { AppModal } from '../../../../../generic/ui/Modal'
import DivideModal from '../modal/DivideModal'
import IconTextField from '../../../../../generic/ui/Input/IconTextField'
import BarcodeIcon from '../../../../../generic/icons/IconLib/BarcodeIcon'
import useScannedDataHandler from '../../kosherTeudot/Hooks/useScannedDataHandler'
import useCreateMiun from '../services/hooks/useCreateMiun'
import MiunPageLayout from '../Components/MiunPageLayout'
import MiunTitleCard from './Components/MiunTitleCard'
import EntryAvailableCard from './Components/EntryAvailableCard'
import MiunCreateScrollArea from './Components/MiunCreateScrollArea'
import MiunActionDock from './Components/MiunActionDock'
import MiunTabSelector from './Components/MiunTabSelector'

const CreateMiun: React.FC = () => {
    const {
        refBody,
        selectedSortingItem,
        input,
        setInput,
        selectedTab,
        setSelectedTab,
        renderEntries,
        givenEntries,
        isOpenDivideModal,
        handleOpenDivideModal,
        selectedItemForDivide,
        selectForDivide,
        MoveEntriesAPI,
        changeWeight,
        saveDevidedItem,
        handleBack,
        warehouseList,
        packageList,
    } = useCreateMiun()

    useScannedDataHandler(refBody)

    const lastIndex = renderEntries.length - 1

    return (
        <MiunPageLayout
            title={`כניסות לסידור #${selectedSortingItem?.Sorting_Num ?? ''}`}
        >
            <MiunCreateScrollArea
                scrollHeader={
                    selectedSortingItem ? (
                        <MiunTitleCard
                            data={selectedSortingItem}
                            givenCount={givenEntries.length}
                        />
                    ) : null
                }
                stickyHeader={
                    <StickyRow>
                        <SearchSlot>
                            <IconTextField
                                value={input}
                                onChange={(e) => setInput(e.target.value)}
                                leadingIcon={<BarcodeIcon color='currentColor' size={16} />}
                                placeholder='סריקה / חיפוש'
                                inputMode='search'
                            />
                        </SearchSlot>
                        <FilterSlot>
                            <MiunTabSelector
                                value={selectedTab}
                                onChange={setSelectedTab}
                            />
                        </FilterSlot>
                    </StickyRow>
                }
            >
                {renderEntries.map((item, idx) => (
                    <EntryAvailableCard
                        key={item.id ?? `${item.EntryNum}-${item.DetailNum}`}
                        item={item}
                        isLast={idx === lastIndex}
                        moveItem={MoveEntriesAPI}
                        selectForDivide={selectForDivide}
                        changeWeight={changeWeight}
                    />
                ))}
            </MiunCreateScrollArea>

            <MiunActionDock onBack={handleBack} />

            {isOpenDivideModal && (
                <AppModal
                    size='sm'
                    title={`${selectedItemForDivide?.EntryNum}-${selectedItemForDivide?.DetailNum} פיצול כניסה`}
                    Children={DivideModal}
                    childrenProps={{
                        item: selectedItemForDivide,
                        saveFunc: saveDevidedItem,
                        warehouseList,
                        packageList,
                    }}
                    controlFunc={handleOpenDivideModal}
                />
            )}
        </MiunPageLayout>
    )
}

export default CreateMiun

const StickyRow = styled.div`
    display: flex;
    align-items: center;
    gap: 0.5rem;
    direction: rtl;
`

const SearchSlot = styled.div`
    flex: 1;
    min-width: 0;
`

const FilterSlot = styled.div`
    flex-shrink: 0;
    width: 10rem;

    @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
        width: 8rem;
    }
`
